
import { TranslationSet } from '../types';

export const login: TranslationSet = {
  'login.title': {
    en: 'Login',
    ja: 'ログイン',
    es: 'Iniciar sesión',
    zh: '登录',
    fa: 'ورود'
  },
  'login.subtitle': {
    en: 'Welcome back! Enter your credentials to access your account.',
    ja: 'おかえりなさい！アカウントにアクセスするには資格情報を入力してください。',
    es: '¡Bienvenido de nuevo! Introduce tus credenciales para acceder a tu cuenta.',
    zh: '欢迎回来！输入您的凭据以访问您的账户。',
    fa: 'خوش آمدید! اطلاعات حساب خود را وارد کنید.'
  },
  'login.form.email': {
    en: 'Email',
    ja: 'メールアドレス',
    es: 'Correo electrónico',
    zh: '电子邮件',
    fa: 'ایمیل'
  },
  'login.form.password': {
    en: 'Password',
    ja: 'パスワード',
    es: 'Contraseña',
    zh: '密码',
    fa: 'رمز عبور'
  },
  'login.form.login': {
    en: 'Sign in with Email',
    ja: 'メールでログイン',
    es: 'Iniciar sesión con correo electrónico',
    zh: '使用邮箱登录',
    fa: 'ورود با ایمیل'
  },
  'login.form.forgotPassword': {
    en: 'Forgot Password?',
    ja: 'パスワードをお忘れですか？',
    es: '¿Olvidaste tu contraseña?',
    zh: '忘记密码？',
    fa: 'رمز عبور را فراموش کرده‌اید؟'
  },
  'login.noAccount': {
    en: 'Don\'t have an account?',
    ja: 'アカウントをお持ちでないですか？',
    es: '¿No tienes una cuenta?',
    zh: '没有账户吗？',
    fa: 'حساب کاربری ندارید؟'
  },
  'login.createOne': {
    en: 'Create one',
    ja: '作成する',
    es: 'Crear una',
    zh: '创建一个',
    fa: 'ایجاد حساب'
  },
  'login.errorMessage': {
    en: 'Invalid email or password',
    ja: 'メールアドレスまたはパスワードが無効です',
    es: 'Correo electrónico o contraseña inválidos',
    zh: '无效的电子邮件或密码',
    fa: 'ایمیل یا رمز عبور نامعتبر است'
  },
  'login.errorTitle': {
    en: 'Login failed',
    ja: 'ログインに失敗しました',
    es: 'Error de inicio de sesión',
    zh: '登录失败',
    fa: 'ورود ناموفق'
  },
  'login.googleErrorTitle': {
    en: 'Google sign-in failed',
    ja: 'Googleログインに失敗しました',
    es: 'Error de inicio de sesión con Google',
    zh: 'Google登录失败',
    fa: 'ورود با گوگل ناموفق بود'
  },
  'login.missingCredentials': {
    en: 'Please fill in both email and password fields',
    ja: 'メールアドレスとパスワードの両方を入力してください',
    es: 'Por favor complete tanto el correo electrónico como la contraseña',
    zh: '请填写电子邮件和密码字段',
    fa: 'لطفا هر دو فیلد ایمیل و رمز عبور را پر کنید'
  },
  'login.signingIn': {
    en: 'Signing in...',
    ja: 'ログイン中...',
    es: 'Iniciando sesión...',
    zh: '登录中...',
    fa: 'در حال ورود...'
  },
  'login.or': {
    en: 'OR',
    ja: 'または',
    es: 'O',
    zh: '或',
    fa: 'یا'
  },
  'login.emailPlaceholder': {
    en: 'you@example.com',
    ja: 'あなた@例.com',
    es: 'tu@ejemplo.com',
    zh: '你@例子.com',
    fa: 'شما@مثال.com'
  }
};
